import { useBrandTheme } from '@hooks';

/**
 * Component that manages automatic theme application based on store brand
 * This should be placed within the StoreProvider to ensure it has access to store data
 */
const ThemeManager: React.FC = () => {
  useBrandTheme();
  return null; // This component doesn't render anything
};

export default ThemeManager;
